import type { ComponentProps } from "react"
import { DialogHeader as DialogHeaderBase } from "@/v2-ui/dialog/base/DialogBase"
import cn from "@/v2-ui/utils/utils.cn"

export type DialogHeaderProps = ComponentProps<typeof DialogHeaderBase>

function DialogHeader(props: DialogHeaderProps) {
  const { className, ...dialogHeaderBaseProps } = props
  return (
    <DialogHeaderBase
      className={cn("ui-dialog-header", className)}
      {...dialogHeaderBaseProps}
    />
  )
}

export default DialogHeader
